<template>
  <div class="card mb-4">
    <div class="card-header">
      <h2>Historie</h2>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-history">
          <thead>
            <tr>
              <th>Periode</th>
              <th>Deelnemers (arbeidsongeschikt)</th>
              <th>Totaal te innen</th>
              <th>Geïnd</th>
              <th>Openstaand</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="batch in batches" :key="batch.id">
              <td>{{ new Date(batch.created_at).toLocaleDateString('nl-NL', {month: 'long', year: 'numeric'}) }}</td>
              <td>{{ batch.member_count }} ({{ batch.sick_member_count }})</td>
              <td>€ {{ batch.amount_needed | currency }}</td>
              <td>€ {{ batch.amount_paid | currency }}</td>
              <td>€ {{ batch.amount_not_paid | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        batches: {
            type: Array,
            default: () => [],
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/PreviousBatches.vue